import { CountryCode } from '../types';
export const getCountryCode = (locale, defaultValue = CountryCode.US) => { var _a; return ((_a = Object.entries(CountryCode).find(([key]) => key === locale.split('-')[1])) === null || _a === void 0 ? void 0 : _a[1]) || defaultValue; };
//# sourceMappingURL=locale.js.map